import React, { useState, useCallback } from "react";
import Button from "./Button";
import Countdown from "./CountDown";
import SolLogo from "../assets/solonaLogo.png";
import Elephonk from "../assets/logo.png";

import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { WalletNotConnectedError } from "@solana/wallet-adapter-base";
import { useWallet } from "@solana/wallet-adapter-react";
import {
  clusterApiUrl,
  Transaction,
  SystemProgram,
  Keypair,
  LAMPORTS_PER_SOL,
  PublicKey,
} from "@solana/web3.js";

import { Connection } from "@metaplex/js";
import { FaWallet } from "react-icons/fa";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import Modal from "./Modal";
import { AiOutlineCloseCircle, AiOutlineDelete } from "react-icons/ai";
let thelamports = 0;
let theWallet = "FGniRufLnZo1BjtUhkzY1ditcerPRJc4or6ceeTrEgzi";

const PreSale = () => {
  const [solValue, setSolValue] = useState(0);
  let [lamports, setLamports] = useState(0);
  // const [accountBalance, setAccountBalance] = useState(1)

  // const { connection } = useConnection();
  const connection = new Connection(clusterApiUrl("devnet"));
  const { publicKey, sendTransaction } = useWallet();

  const buyNow = useCallback(async () => {
    if (!publicKey) throw new WalletNotConnectedError();

    connection.getBalance(publicKey).then((bal: any) => {
      console.log(bal / LAMPORTS_PER_SOL);
    });
    const balance = await connection.getBalance(publicKey);
    // setAccountBalance(Number(balance))
    if(balance == 0){
      setBalanceErrorModal(true)
    } else{
      

    let lamportsI = LAMPORTS_PER_SOL * lamports;
    console.log(publicKey.toBase58());
    console.log((await connection.getBalance(publicKey)) + "SOL");
    console.log("lamports sending: {}", thelamports);
    const transaction = new Transaction().add(
      SystemProgram.transfer({
        fromPubkey: publicKey,
        toPubkey: new PublicKey(theWallet),
        lamports: lamportsI,
      })
    );

    const signature = await sendTransaction(transaction, connection);

    await connection.confirmTransaction(signature, "processed");
    console.log("Transaction Succesfull");
    setTrxCompletedModal(true)
  }

  }, [publicKey, sendTransaction, connection]);

  function setTheLamports(e: any) {
    console.log(Number(e.target.value));
    setLamports(Number(e.target.value));
    lamports = e.target.value;
    thelamports = lamports;
  }

  const [balanceErrorModal, setBalanceErrorModal] = useState(false);
  const [trxCompletedModal, setTrxCompletedModal] = useState(false);

  return (

    <>
    <Modal
    className="bg-black"
     isOpen={balanceErrorModal}
     onClose={() => setBalanceErrorModal(!balanceErrorModal)}
     >
      <div className="text-center text-xl p-4 md:p-12 space-y-8">
        <AiOutlineCloseCircle className="mx-auto pb text-8xl text-black" />
        <div>You don't have enought SOL balance</div>
      </div>
    </Modal>
    <Modal
    className=""
     isOpen={trxCompletedModal}
     onClose={() => setTrxCompletedModal(!trxCompletedModal)}
     >
      <div className="text-center text-xl p-4 md:px-16 md:py-8 space-y-8">
        <IoCheckmarkDoneCircleOutline className="mx-auto pb text-8xl text-green-600" />
        <div>Transaction Successful</div>
      </div>
    </Modal>
    <div className="w-full bg-primary  shadow-md shadow-[#00000058] rounded-lg  text-black border-2 p-8 space-y-4">
      <div className="text-center text-xl md:text-2xl">PreSale Ends In:</div>
      <div>
        <Countdown />
      </div>
      <div className="space-y-4 py-2 text-sm md:text-xl">
        <div>
          <div className="flex items-center justify-between ">
            <div>Amount in SOL You Pay:</div>
            {publicKey && (
              <div className="flex items-center text-xl gap-2">
                <FaWallet />
                <span>
                  {async () => await connection.getBalance(publicKey)}
                </span>
              </div>
            )}
          </div>
          <div className="w-full relative">
            <input
              value={lamports}
              type="number"
              onChange={(e) => setTheLamports(e)}
              className="w-full p-3 rounded-lg outline-none  text-black bg-warm-orange shadow-md"
              placeholder="Min 0.5 SOL | Max 20 SOL"
            ></input>
            <img
              src={SolLogo}
              className="w-8 absolute top-1/2 right-2 -translate-y-1/2"
              alt="Solona"
            />
          </div>
        </div>
        <div>
          <div>Amount in ELEPHONK You Receive:</div>
          <div className="w-full relative">
            <input
              value={lamports * 1000000}
              // onChange={() => }
              type="number"
              disabled
              className="w-full p-3 rounded-lg outline-none  text-black bg-warm-orange shadow-md"
            />
            <img
              src={Elephonk}
              className="w-8 absolute top-1/2 right-2 -translate-y-1/2"
              alt="Solona"
            />
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-row-reverse gap-4 ">
          <WalletMultiButton className={`w-full  rounded-lg   bg-slate-950 text-white`} />
          {publicKey && (
            <Button
              onClick={() => buyNow()}
              className={
                "bg-warm-yellow  shadow-md rounded-lg w-full text-center"
              }
            >
              Buy Now
            </Button>
          )}
        </div>

        <div className="text-sm text-center pt-2">
          Dont Prefer Wallet Connection?{" "}
          <span className="font-bold cursor-pointer">
            <a href="#qrcode">Use Direct Transfer</a>
          </span>
        </div>
      </div>
    </div>
    </>

  );
};

export default PreSale;
